import React from "react";
import { Header } from "./components/Header";
import { HeaderSkeleton } from "./components/HeaderSkeleton";
import { PriorityTasks } from "./components/PriorityTasks";
import { PriorityTasksSkeleton } from "./components/PriorityTasksSkeleton";
import { PerformanceMetrics } from "./components/PerformanceMetrics";
import { PerformanceMetricsSkeleton } from "./components/PerformanceMetricsSkeleton";
import { get } from "utils/localStorage";
import endpoints from "modules/Retention/constants/endpoints";
import { useQuery } from "@tanstack/react-query";
import { fetchTaskCenterSummary } from "modules/Retention/services/retention";

export default function Home() {
  const { data, isLoading } = useQuery({
    queryKey: [endpoints.taskCenterSummary],
    queryFn: fetchTaskCenterSummary,
    select: (res: any) => res?.result,
  });

  const atRiskTasks = data?.action_needed ? {
    ...data.action_needed,
    items: data.action_needed.items || [],
    count: data.action_needed.count - (data.action_needed.items?.find((item: any) => item.label === "No response")?.count || 0),
    dueText: data.action_needed.dueText || ""
  } : {
    count: 0,
    items: [],
    dueText: ""
  };

  const inProgressTasks = data?.in_progress || {
    count: 0,
    items: [],
    dueText: ""
  };

  const performanceData = {
    responseRate: {
      avg: 10,
      yourValue: 60,
      bestValue: 90,
      avgPercentage: 50,
      yourPercentage: 60,
      bestPercentage: 20
    },
    sentimentScore: {
      avg: 70,
      yourValue: 60,
      bestValue: 80,
      avgPercentage: 50,
      yourPercentage: 60,
      bestPercentage: 20
    },
    timeOfResolve: {
      avg: 10,
      yourValue: 12,
      bestValue: 5,
      avgPercentage: 50,
      yourPercentage: 60,
      bestPercentage: 20
    }
  };

  return (
    <div className="flex h-full w-full flex-col items-start gap-2 bg-default-background">
      {isLoading ? <HeaderSkeleton /> : <Header userName={get("full_name") as string} />}
      <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-2 overflow-auto">
        <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-8 bg-[#f9fafbff] px-4 sm:px-6 md:px-12 py-6 md:py-12">
          {isLoading ? (
            <PriorityTasksSkeleton />
          ) : (
            <PriorityTasks 
              atRiskTasks={atRiskTasks} 
              inProgressTasks={inProgressTasks} 
            />
          )}
          {isLoading ? (
            <PerformanceMetricsSkeleton />
          ) : (
            <PerformanceMetrics {...performanceData} />
          )}
        </div>
      </div>
    </div>
  );
} 